import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import NavBar from './components/NavBar';
import Home from './pages/home/Home';
import Games from './pages/games/Games';
import Players from './pages/players/Players';
import Visualizations from './pages/visualizations/Visualizations';
import { DataProvider } from './components/DataContext'; 

function App() {
  return (
    <DataProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/home" element={<Home />} />
          <Route path="/games" element={<Games />} />
          <Route path="/players" element={<Players />} />
          <Route path="/visualizations" element={<Visualizations />} />
        </Routes>
        <NavBar />
      </BrowserRouter>
    </DataProvider>
  );
}

export default App;
